import * as React from "react";
import day from "dayjs";
import type { Dayjs } from "dayjs";
import locale from "antdv5/es/date-picker/locale/zh_CN";
import { Radio, Space, Input, DatePicker as DatePickerAntd } from "antdv5";
import DatePicker from "react-datepicker";
import { OrderContent as OrderContentComponent } from "./DeviceOrder.style";
import type { Fn, SetState } from "../../../client_types";

interface IProps {
  show: boolean;
  send: boolean;
  min: number;
  time: number;
  startDate: Date;
  deviceName: string[];
  datePickerRef: any;
  getValue: number;
  orderContent: string | null;
  setSend: SetState<boolean>;
  setStartDate: SetState<Date>;
  setTime: SetState<number>;
  setMin: SetState<number>;
  setGetValue: SetState<number>;
  setShow: SetState<boolean>;
  setOrderContent: SetState<string | null>;
  addYears: (date: Date, years: number) => Date;
  handleSubmit: Fn;
}

const range = (size: number, startAt = 0) => {
  const a = Array(size);
  for (let i = startAt; i < size; i++) {
    a[i] = i;
  }
  return a;
};

const ReadonlyInput = React.forwardRef(({ value, onClick }: any, ref: any) => (
  <div className="customInput" onClick={onClick} ref={ref}>
    {value}
  </div>
));

const OrderContent = ({
  show,
  send,
  deviceName,
  setSend,
  startDate,
  setStartDate,
  addYears,
  datePickerRef,
  setTime,
  setMin,
  setGetValue,
  getValue,
  setShow,
  handleSubmit,
  setOrderContent,
  orderContent,
  min,
  time,
}: IProps) => {
  return (
    <OrderContentComponent show={show} send={send}>
      <div className="allDevice">
        <p>已选踏板：{deviceName && deviceName.join(", ")}</p>
        <p>踏板数量: {deviceName ? deviceName.length : "0"} 台</p>
      </div>
      <Radio.Group onChange={(e) => setSend(e.target.value)} value={send}>
        <Space direction="vertical">
          <Radio value={true}>立即发送</Radio>
          <Radio value={false}>预约发送</Radio>
        </Space>
      </Radio.Group>
      <div className="dateOutter">
        <DatePicker
          selected={startDate}
          fixedHeight
          onChange={(update) => {
            update !== null && update > new Date()
              ? setStartDate(update)
              : setStartDate(new Date());
          }}
          timeInputLabel="时间:"
          dateFormat="yyyy-MM-dd"
          showPopperArrow={false}
          minDate={new Date()}
          maxDate={addYears(new Date(), 1)}
          locale="zh"
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          ref={datePickerRef}
          customInput={<ReadonlyInput />}
          disabled={send}
          todayButton="今日"
        />
        <div className="timeOutter">
          <div className="wrapperSelect">
            <select
              className="timeSelect"
              onChange={(e) => {
                setTime(parseInt(e.target.value) || 0);
                e.preventDefault();
              }}
              defaultValue={time}
              disabled={send}
            >
              {range(24, 0).map((item, i) => (
                <option key={i}>
                  {item.toString().length === 2 ? item : "0" + item}
                </option>
              ))}
            </select>
            <p>时</p>
          </div>
          <div className="wrapperSelect">
            <select
              className="timeSelect"
              onChange={(e) => {
                setMin(parseInt(e.target.value) || 0);
                e.preventDefault();
              }}
              defaultValue={min}
              disabled={send}
            >
              {range(60, 0).map((item, i) => (
                <option key={i}>
                  {item.toString().length === 2 ? item : "0" + item}
                </option>
              ))}
            </select>
            <p>分</p>
          </div>
        </div>
      </div>
      <Radio.Group
        onChange={(e) => setGetValue(e.target.value)}
        value={getValue}
      >
        <Space direction="vertical">
          <Radio value={1}>鸽钟侦测</Radio>
          <Radio value={2}>
            自订命令
            <Input.TextArea
              rows={5}
              cols={100}
              disabled={getValue === 1}
              value={orderContent || ""}
              onChange={(e) => setOrderContent(e.target.value)}
              placeholder="请输入内容"
              style={{
                padding: ".5rem",
                borderRadius: ".5rem",
                margin: ".5rem 0 1rem 0",
              }}
            />
          </Radio>
        </Space>
      </Radio.Group>
      <div className="btnGroup">
        <button className="btn" onClick={handleSubmit}>
          发送
        </button>
        <button
          className="btn back"
          onClick={() => {
            setShow(false);
          }}
        >
          取消
        </button>
      </div>
    </OrderContentComponent>
  );
};

export default OrderContent;
